import React, { Component } from 'react';
import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics'
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-select';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class Catalog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      catalog: <div id="loading-catalog"><div className="fa fa-spinner fa-spin"></div></div>,
      preview: ''
    }
    this.renderCatalog = this.renderCatalog.bind(this);
  }

  renderCatalog(data) {
    let trackList = data.map((track, index) => {
      return (
        <tr key={track.id} data-id={track.id} id={track.id}>
          <td></td>
          <td align="center">
            <i className="fa fa-play-circle play-preview" data-id={track.id} aria-hidden="true" data-toggle="tooltip" data-placement="top" title="Preview the track"></i>
            <i className="fa fa-pause-circle pause-preview" data-id={track.id} aria-hidden="true" data-toggle="tooltip" data-placement="top" title="Pause the track"></i>
          </td>
          <td>
            <span className="song-title">{track.title}</span>
          </td>
          <td>
            {track.artist}
          </td>
          <td>
            <span>{track.playcount}</span>
          </td>
          <td data-order={track.added_sort}>
            {track.added}
          </td>
          <td>
            <button type="button" className="btn btn-default dropdown-toggle justify-content-center align-self-center" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
            </button>
            <div className="dropdown-menu">
              <button className="dropdown-item add-song from-catalog" onClick={() => {this.props.addSong(track.id)}} data-toggle="modal" data-target=".modal"><i className="fa fa-plus" aria-hidden="true"></i> Add</button>
              <button className="dropdown-item rate-song from-catalog" onClick={() => {this.props.rateSong(track.id)}} data-toggle="modal" data-target=".modal"><i className="fa fa-star" aria-hidden="true"></i> Rate</button>
              <button className="dropdown-item info-song from-catalog" onClick={() => {this.props.infoSong(track.id)}} data-toggle="modal" data-target=".modal"><i className="fa fa-info pl-1" aria-hidden="true"></i> Info</button>
            </div>
          </td>
        </tr>
      );
    });
    return trackList;
  }

  componentDidMount() {
    let $pinned = localStorage.getItem('pinnedPlaylistDrawer');
    if ($pinned === '1') {
      localStorage.setItem('pinnedPlaylistDrawer', 1);
      $('#pin-playlists, #playlists, #jukebox, #catalog, a.navbar-brand').addClass('pinned');
    }

    const params = new URLSearchParams(window.location.search),
          sa = params.get('sa');
    if (sa == 'success') {
      toast.success('Your songs have been added.', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    $('[data-toggle="tooltip"]').tooltip();
    localStorage.setItem('previewSongID','');
    let formData = new FormData();
      formData.append('task', 'catalog');
      formData.append('userid', localStorage.getItem('userid'));
      formData.append('auth_token', localStorage.getItem('auth_token'));
      return fetch('https://www.d-cot.com/api/jukebox/', {
        method: 'POST',
        mode: 'cors',
        headers:{
          'Access-Control-Allow-Origin':'*'
        },
        body: formData
        })
        .then((response) => response.json())
        .then((responseJson) => {
          let data = responseJson;
          if (data[0].not_auth === 'fail') {
            window.location = '/';
          }
          if (data) {
            this.setState({
              catalog: this.renderCatalog(data)
            });
            let previewTimeout;
            function previewTrack() {
              $('.play-preview').on('click touchend', function(e){
                clearTimeout(previewTimeout);
                if (localStorage.getItem('previewSongID') !== $(this).data('id')) {
                  //load preview of the song
                  let formData = new FormData();
                    formData.append('task', 'preview');
                    formData.append('songID', $(this).data('id'));
                    formData.append('userid', localStorage.getItem('userid'));
                    formData.append('auth_token', localStorage.getItem('auth_token'));
                    return fetch('https://www.d-cot.com/api/jukebox/', {
                      method: 'POST',
                      mode: 'cors',
                      headers:{
                        'Access-Control-Allow-Origin':'*'
                      },
                      body: formData
                      })
                      .then((response) => response.json())
                      .then((responseJson) => {
                        let data = responseJson;
                        if (data) {
                          $('.pause-preview').each(function(){
                            $(this).hide();
                          });
                          $('.play-preview').each(function(){
                            $(this).show();
                          });
                          let $url = data[0].url,
                              $audio = document.getElementById('preview-player'),
                              $source = document.getElementById('audio-source');
                          $source.src = $url;
                          $audio.load();
                          $audio.volume = localStorage.getItem('volLevel');
                          $audio.play();
                          $(this).hide();
                          $('.pause-preview[data-id='+$(this).data('id')+']').show();
                          localStorage.setItem('previewSongID',$(this).data('id'));

                          $audio.addEventListener("canplaythrough", function () {
                            previewTimeout = setTimeout(function(){
                                $audio.pause();
                                $('.pause-preview[data-id='+localStorage.getItem('previewSongID')+']').hide();
                                $('.play-preview[data-id='+localStorage.getItem('previewSongID')+']').show();
                                $audio.currentTime = 0;
                            }, 30000);
                          }, false);

                          $('.pause-preview').on('click touchend', function(e){
                            $audio.pause();
                            $(this).hide();
                            $('.play-preview[data-id='+$(this).data('id')+']').show();
                          });
                        }
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                } else {
                  let $audio = document.getElementById('preview-player');
                  $audio.play();
                  $(this).hide();
                  $('.pause-preview[data-id='+$(this).data('id')+']').show();
                  $('.pause-preview').on('click touchend', function(e){
                    $audio.pause();
                    $(this).hide();
                    $('.play-preview[data-id='+$(this).data('id')+']').show();
                  });
                }

              });
            }
            let $table = $('#catalog-tracks').DataTable({
              columnDefs: [ {
                orderable: false,
                className: 'select-checkbox',
                targets:   0
              } ],
              select: {
                //style:    'os',
                info: false,
                style: 'multi',
                selector: 'td:first-child'
              },
              order: [[ 1, 'asc' ]]
            });


              console.log('account '+this.props.account);

            //add button to add group of songs
            $('#catalog-tracks_length label').append(`<button data-account=${this.props.account} id="add-group-songs" class="btn btn-primary"><i className="fa fa-plus" aria-hidden="true"></i> Add Selected Songs</button>`);
            //add listener to add the songs
            $('#add-group-songs').on('click touchend', function(e){
              let $rowIDs = $table.rows( { selected: true } ).ids().toArray();

              if (!$rowIDs || $rowIDs == '') {
                $('.modal .modal-title').html('<i class="fa fa-music" aria-hidden="true"></i> Add Selected Songs');
                $('.modal .modal-body').html('<div class="alert alert-danger" role="alert" style="margin: 10px 0 0 0;">Please select at least one song.</div>');
                $('.modal .modal-footer').html('<button type="button" class="btn btn-secondary close-selected-songs" data-dismiss="modal">Close</button>');

                $('.modal').modal();
                return false;
              }
              //grab custom playlist names and ids
              let $customPlaylistsAddSong = '';
              $('.playlist.user-playlist').each(function(){
                let $customName = $(this).data('name'),
                    $customID = $(this).data('id');
                    $customPlaylistsAddSong = $customPlaylistsAddSong+'<option value="'+$customID+'">'+$customName+'</option>';
              });

              $('.modal .modal-title').html('<i class="fa fa-music" aria-hidden="true"></i> Add Selected Songs');
              let $account = $('#add-group-songs').data('account');
              if ($account == '1' || $account == '2') {
                $('.modal .modal-body').html('<p><strong>Add the selected songs to a playlist.</strong></p><form><div class="form-group"><select id="add-song" class="form-control"><option value="">Choose a playlist</option>'+$customPlaylistsAddSong+'</select></form><br /><div class="add-new-playlist"><p><strong>Create a New Playlist</p><input type="text" id="new-playlist" class="form-control"></div><div class="alert msg alert-danger" role="alert" style="display: none; margin: 10px 0 0 0;"></div>');
              } else {
                $('.modal .modal-body').html('<p><strong>Add the selected songs to a playlist.</strong></p><form><div class="form-group"><select id="add-song" class="form-control"><option value="">Choose a playlist</option>'+$customPlaylistsAddSong+'</select></form><br /><div class="alert alert-info" role="alert" style="margin: 10px 0 0 0;">You can create custom playlists as a supporter.<br /><a href="https://www.d-cot.com/become-a-supporter/" rel="noopener nofollow" target="_blank">Click here to join!</a></div><div class="alert msg alert-danger" role="alert" style="display: none; margin: 10px 0 0 0;"></div>');
              }
              $('.modal .modal-footer').html('<button type="button" class="btn btn-secondary close-selected-songs" data-dismiss="modal">Close</button><button type="button" class="btn btn-primary save-selected-songs">Add Selected Songs</button>');

              $('.modal').modal();

              $('.save-selected-songs').on('click touchend', function(){
                let $option = $('#add-song option:selected').val(),
                    $newPlaylist = $('#new-playlist').val();
                if (!$option && !$newPlaylist) { //no playlist or create new playlist
                  $('.modal .modal-body .msg').html('Please choose a playlist or create a new one.').slideDown();
                } else if ($option && $newPlaylist) { //playlist and create new playlist
                  //we need to tell them to choose one
                  $('.modal .modal-body .msg').html('You selected a playlist and typed in a new playlist.<br />Please choose only one.').slideDown();
                } else {
                  let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
                  if (format.test($newPlaylist) !== false && $newPlaylist.length > 40) {
                    $('.modal .modal-body .msg').html('Your playlist name either contains special characters or is greater than 40 characters. Please only user letters, numbers and spaces.').slideDown().delay(10000).slideUp();
                  } else {
                    //create new playlist and then add song to it
                    $('.modal .modal-footer button.close-selected-songs').prop('disabled',true);
                    $('.modal .modal-footer button.save-selected-songs').html('Adding <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>').prop('disabled',true);
                    let $rowIDs = $table.rows( { selected: true } ).ids().toArray();
                    let formData = new FormData();
                    formData.append('songIDs', $rowIDs);
                    if (!$option && $newPlaylist) { //no option and create new playlist
                      formData.append('newPlaylist', $newPlaylist);
                    } else {
                      formData.append('playlistID', $option);
                    }
                    formData.append('task', 'add_selected_songs');
                    formData.append('userid', localStorage.getItem('userid'));
                    formData.append('auth_token', localStorage.getItem('auth_token'));
                    return fetch('https://www.d-cot.com/api/jukebox/', {
                      method: 'POST',
                      mode: 'cors',
                      headers:{
                        'Access-Control-Allow-Origin':'*'
                      },
                      body: formData
                      })
                      .then((response) => response.json())
                      .then((responseJson) => {
                        let data = responseJson;
                        if (data) {
                          if (data[0].status === 'success') {
                            $('.modal .modal-footer button.save-selected-songs').html('Added <i class="fa fa-check" aria-hidden="true"></i>');
                            $('.modal .modal-footer button.close-selected-songs').prop('disabled',false);

                            setTimeout(() => {
                              $('.modal .modal-footer button.save-selected-songs').html('Add Selected Songs').prop('disabled',false);
                              window.location = '/catalog/?sa=success';
                            }, 1000);
                            const analytics = Analytics({
                              app: 'dcot-jukebox',
                              plugins: [
                                googleAnalytics({
                                  trackingId: 'UA-82751-3'
                                })
                              ]
                            });
                            analytics.track('Added Selected Songs', {
                              category: 'Jukebox',
                              action: 'Added Song',
                              label: $rowIDs
                            });
                          } else if (data[0].status === 'dupe') {
                            $('.modal .modal-body .alert').html('One of these songs are already in your playlist.').slideDown();
                            $('.modal .modal-footer button.save-selected-songs').html('Add Selected Songs').prop('disabled',false);
                            $('.modal .modal-footer button.close-selected-songs').prop('disabled',false);
                          } else {
                            $('.modal .modal-body .alert').html('There was an error. Please try again later.').slideDown();
                            $('.modal .modal-footer button.save-selected-songs').html('Add Selected Songs').prop('disabled',false);
                            $('.modal .modal-footer button.close-selected-songs').prop('disabled',false);
                            $('.modal .modal-footer button.save-selected-songs').prop('disabled',true);
                          }
                        }
                    })
                    .catch((error) => {
                      console.error(error);
                      $('.modal .modal-body .alert').html('There was an error. Please try again later.').slideDown();
                      $('.modal .modal-footer button.save-selected-songs').html('Add');
                      $('.modal .modal-footer button.close-selected-songs').prop('disabled',false);
                      $('.modal .modal-footer button.save-selected-songs').prop('disabled',true);
                    });
                  }
                }
              });
            });
            previewTrack();
            $table.on('draw', function(){
              previewTrack();
            });
          }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    return (
      <div id="catalog" className="main pt-5 mt-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <h2>Music Catalog</h2>
              <div className="table-responsive">
                <table id="catalog-tracks" className="table table-hover table-striped track-list" cellSpacing="0" width="100%">
                  <thead>
                   <tr>
                     <th scope="col" width="1%" className="no-sort">&nbsp;</th>
                     <th scope="col" width="2%" className="no-sort">&nbsp;</th>
                     <th scope="col" width="31%" className="text-uppercase">Track Name</th>
                     <th scope="col" width="7%" className="text-uppercase">Playlist</th>
                     <th scope="col" width="3%" className="text-uppercase">Playcount</th>
                     <th scope="col" width="3%" className="text-uppercase">Date Added</th>
                     <th scope="col" width="1%" align="right" className="no-sort">&nbsp;</th>
                   </tr>
                  </thead>
                  <tbody>
                    {this.state.catalog}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <audio id="preview-player">
          <source id="audio-source" src=""></source>
        </audio>
      </div>
    );
  }
}

export default Catalog;
